// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	TenantName: 'tenant-name',
	PhoneNumber: 'phone-number',
	LeaseStartDate: 'lease-start-date',
	LeaseEndDate: 'lease-end-date',
	Rent: 'rent',
	Deposit: 'deposit',
	AddTenantButton: 'add-tenant-button',
	CancelButton: 'cancel-button',
	SaveButton: 'save-button',
} as const;
